"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ShimmerAnimation = (0, _styledComponents.keyframes)(["0%{background-position:-468px 0;}100%{background-position:468px 0;}"]);

const ShimmerBox = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "ShimmerBox",
  componentId: "u7aqn1-0"
})(["background:#f6f7f8;background-image:linear-gradient( to right,#f6f7f8 0%,#edeef1 20%,#f6f7f8 40%,#f6f7f8 100% );background-repeat:no-repeat;animation:", " 1s linear infinite;"], ShimmerAnimation);

/** @component */
exports.default = ShimmerBox;